import React from "react";
import { Button } from "../button/Button";

import styles from "./SubmitButton.module.scss";

export const SubmitButton = (props: React.ComponentProps<typeof Button>) => (
  <Button
    type="submit"
    variant="contained"
    className={styles.submitButton}
    size="large"
    {...props}
  >
    {props.children}
  </Button>
);
